import { pick } from 'ramda';
import React, { useMemo } from 'react';
import { Menu } from 'js/components/main/Menu';
import { Header } from 'js/components/main/Header';
import { Footer } from 'js/components/main/Footer';
import { Reconnect } from 'js/components/main/Reconnect';
import { SlideMenu } from 'js/components/main/SlideMenu';
import { BACKBONE_APP_ROOT } from 'js/backbone/constants';
import { AboveHeader } from 'js/components/main/AboveHeader';
import { WebContent } from 'js/components/system/WebContent';
import { useAppSelector } from 'js/store/hooks';
import { useUpdateHeaderHeight } from 'js/components/system/App/hooks';
import { MyAccountSidebar } from 'js/components/main/MyAccountSidebar';
import { SignInNotificationBanner } from 'js/components/main/SignInNotificationBanner';
import { CookiesRegulationMessage } from 'js/components/main/CookiesRegulationMessage';

import { PageRouter } from '../PageRouter';
import { LAYER_POSITION } from '../../constants';

import style from './AppRouter.scss';

/**
 * Application Router that is aware about business logic.
 */
export const AppRouter = () => {
    const {
        applicationWCID,
        headerHeight,
        cookiesConfiguration: { layerPosition }
    } = useAppSelector(pick(['applicationWCID', 'headerHeight', 'cookiesConfiguration']));
    const headerRef = useUpdateHeaderHeight();
    const contentInlineCss = useMemo(() => ({
        paddingTop: `${headerHeight}px`,
        '--scroll-margin-top': `${headerHeight}px`
    }), [headerHeight]);

    if (applicationWCID) {
        return <WebContent id={applicationWCID} />;
    }

    return (
        <>
            <SlideMenu />
            <MyAccountSidebar />
            <div
                className={`${style.header} header`}
                ref={headerRef}
            >
                <SignInNotificationBanner />
                {layerPosition === LAYER_POSITION.TOP && <CookiesRegulationMessage />}
                <AboveHeader />
                <div className={BACKBONE_APP_ROOT}>
                    <div className="fn-navigation-container navigation-container">
                        <Header />
                        <Menu />
                    </div>
                </div>
            </div>
            <div
                className={style.content}
                style={contentInlineCss}
            >
                <Reconnect />
                <PageRouter />
            </div>
            <Footer />
            {layerPosition === LAYER_POSITION.BOTTOM && (
                <div className={style.cookieLayer}>
                    <CookiesRegulationMessage />
                </div>
            )}
        </>
    );
};
